var classes = {"dropdown":"_93iye","arrow":"_32-jt","dropdownOpened":"_5LDb3"};

export { classes as default };
